import AdminActions from './admin-actions';

const AdminHomeTableStudy = ({studyName, studyDate, studyTime,studyClient, studyCost }) => {

    return (
      
                <tr>
                    <td>{studyName}</td>
                    <td>{studyDate}</td>
                    <td>{studyTime}</td>
                    <td>{studyClient}</td>
                    <td>{studyCost}</td>
                    <td>
                    <AdminActions/>
                    </td>
                </tr>
          
    );
}
export default AdminHomeTableStudy;